export default __webpack_public_path__ + "static/media/objectives_icon_6.374cdfb5.png";